import { useRef } from "react";

import FilterReportDateItens from "../../../../components/filter/reportDateItens/filter";
import reqVendaItem from "../../../../services/reqMultiTenant/reqVendaItem";
import MainReportMatrix from "../../matrix";
import { agruparGrade, somarGrade } from "./agrupar";

const ReportGradeVendidos = () => {
	const cache = useRef({ chave: null, lista: [] });

	const options = {
		title: "Itens Vendidos por Grade",
		subTitle: "Produtos com grade: exibe cada variação vendida agrupada pelo produto pai",
		ident: "gradeVendidos",
		identFilter: "filterGradeVendidos",
		identReport: "reportGradeVendidos",
		tableColumns: [
			{ key: "nome_pai", label: "Produto Base", align: "left" },
			{ key: "nome_variacao", label: "Variação", align: "left" },
			{ key: "qt", label: "Qtde.", align: "center" },
			{ key: "desconto", label: "Desconto", align: "center", format: "currency" },
			{ key: "valor_total", label: "Valor Total", align: "center", format: "currency" },
		],
		reportColumns: [
			{ key: "nome_pai", label: "Produto Base", align: "left" },
			{ key: "nome_variacao", label: "Variação", align: "left" },
			{ key: "qt", label: "Qtde.", align: "center" },
			{ key: "desconto", label: "Desconto", align: "right", format: "currency" },
			{ key: "valor_total", label: "Valor Total", align: "right", format: "currency" },
		],
		showTime: true,
		hasActive: false,
		hasSaleType: false,
		hasParam: true,
		hasSum: true,
		listDataTotal: [
			{ key: "qt", label: "Total Quantidade", format: "" },
			{ key: "desconto", label: "Total Desconto", format: "currency" },
			{ key: "valor_total", label: "Valor Total", format: "currency" },
		],
		parametersDate: [{ id: 1, label: "Data da venda", value: "dtVenda" }],
		parametersFilter: [
			{ id: 1, label: "Produto Base", value: "nome_pai" },
			{ id: 2, label: "Variação", value: "nome_variacao" },
		],
	};

	// O servidor devolve as linhas cruas do período; o agrupamento e o rateio do desconto
	// acontecem aqui. Como o cálculo depende de todas as linhas, a busca é feita uma vez
	// por filtro e as páginas saem do cache — page/perPage não entram na chave.
	const carregar = async (filterData) => {
		const chave = JSON.stringify(filterData);

		if (cache.current.chave !== chave) {
			const response = await reqVendaItem.listGradeVendidosV2(filterData);
			cache.current = { chave, lista: agruparGrade(response.data || []) };
		}

		return cache.current.lista;
	};

	const fetch = async (filterData, newPage, perPage = 15) => {
		const lista = await carregar(filterData);
		const inicio = (newPage - 1) * perPage;

		return { data: lista.slice(inicio, inicio + perPage) };
	};

	const fetchSum = async (filterData) => {
		const lista = await carregar(filterData);

		return { data: [somarGrade(lista)] };
	};

	return (
		<div className="flex flex-col mt-14 min-h-[calc(100vh-6.5rem)]">
			<MainReportMatrix options={options} fetch={fetch} fetchSum={fetchSum} FormFilter={FilterReportDateItens} />
		</div>
	);
};

export default ReportGradeVendidos;
